import React from 'react';
import ProfileOrder from './ProfileOrder';

function ProfileHistoryTab(props) {

   const orderedBikes = [
      { name: 'Road Bike(Carbon)Specializ Rock 18"', price: '90', amountDays: '2', total: '180' },
      { name: 'Road Bike(Carbon)Specializ Rock 18"', price: '90', amountDays: '2', total: '180' },
   ]

   const statusColor = ['1px solid black', 'black'];

   return (
      <div className="currentTab__body">
         <div className="currentTab__header">
            <div className="currentTab__signature signature">Type of rent</div>
            <div className="currentTab__signature signature">Date</div>
            <div className="currentTab__signature signature">Cost</div>
            <div className="currentTab__signature signature">Payment</div>
            <div className="currentTab__signature signature">Status</div>
         </div>
         <div className="currentTab__orders">
            <ProfileOrder
               orderNum={'№00024'}
               date={'2022.11.02'}
               startDate={'2022.11.02'}
               finishDate={'2022.11.4'}
               sum={'650'}
               payment={'Online'}
               status={'Completed'}
               statusColor={statusColor[1]}
               statusBorder={statusColor[0]}
               delivery={'By adress'}
               typeRent={'Days'}
               total={'340'}
               orderedBikes={orderedBikes}
            />
            <ProfileOrder
               isHistoryPage={props.isHistoryPage}
               orderNum={'№00025'}
               date={'2022.10.02'}
               startDate={'2022.10.04'}
               finishDate={'2022.10.06'}
               sum={'430'}
               payment={'On spot'}
               status={'Completed'}
               statusColor={statusColor[1]}
               statusBorder={statusColor[0]}
               delivery={'By adress'}
               typeRent={'Days'}
               total={'240'}
               orderedBikes={orderedBikes}
            />
         </div>
      </div>
   );
}
export default ProfileHistoryTab;